(function () {
  const gridState = {
    desktop: null,
    mobile: null,
  };
  let resizeFrame = null;

  function getProductGrid() {
    return document.getElementById('product-grid');
  }

  function getDefaultColumns(type, grid) {
    if (!grid) return type === 'desktop' ? '4' : '2';

    const configuredValue =
      type === 'desktop' ? grid.dataset.defaultDesktopColumns : grid.dataset.defaultMobileColumns;
    const allowedValues = type === 'desktop' ? ['4', '6'] : ['1', '2'];
    const hardDefault = type === 'desktop' ? '4' : '2';

    return allowedValues.includes(configuredValue) ? configuredValue : hardDefault;
  }

  function getColumnsForType(type, grid) {
    const allowedValues = type === 'desktop' ? ['4', '6'] : ['1', '2'];
    const currentValue = gridState[type];
    return allowedValues.includes(currentValue) ? currentValue : getDefaultColumns(type, grid);
  }

  function applyGridClass(grid, activeColumns, classMap) {
    Object.entries(classMap).forEach(([columns, className]) => {
      grid.classList.toggle(className, columns === activeColumns);
    });
  }

  function replaceResponsiveGridClasses(grid, pattern, nextClass) {
    Array.from(grid.classList).forEach((className) => {
      if (pattern.test(className)) {
        grid.classList.remove(className);
      }
    });

    if (nextClass) {
      grid.classList.add(nextClass);
    }
  }

  function syncToolbarButtons(type, columns) {
    document.querySelectorAll(`[data-grid-view-target="${type}"]`).forEach((button) => {
      const isActive = button.dataset.gridColumns === columns;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyCollectionToolbarState() {
    const grid = getProductGrid();
    if (!grid) return;

    const desktopColumns = getColumnsForType('desktop', grid);
    const mobileColumns = getColumnsForType('mobile', grid);

    gridState.desktop = desktopColumns;
    gridState.mobile = mobileColumns;

    grid.dataset.desktopColumns = desktopColumns;
    grid.dataset.mobileColumns = mobileColumns;
    grid.style.removeProperty('display');
    grid.style.removeProperty('grid-template-columns');
    replaceResponsiveGridClasses(grid, /^grid--\d+-col-desktop$/, `grid--${desktopColumns}-col-desktop`);
    replaceResponsiveGridClasses(grid, /^grid--\d+-col-tablet-down$/, `grid--${mobileColumns}-col-tablet-down`);
    applyGridClass(grid, desktopColumns, {
      4: 'grid--4-col-desktop',
      6: 'grid--6-col-desktop',
    });
    applyGridClass(grid, mobileColumns, {
      1: 'grid--1-col-tablet-down',
      2: 'grid--2-col-tablet-down',
    });

    syncToolbarButtons('desktop', desktopColumns);
    syncToolbarButtons('mobile', mobileColumns);
  }

  function scheduleCollectionToolbarUpdate() {
    if (resizeFrame !== null) return;
    resizeFrame = window.requestAnimationFrame(() => {
      resizeFrame = null;
      applyCollectionToolbarState();
    });
  }

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-grid-view-target]');
    if (!toggleButton) return;

    const grid = getProductGrid();
    if (!grid) return;

    const target = toggleButton.dataset.gridViewTarget;
    const columns = toggleButton.dataset.gridColumns;
    if (!target || !columns) return;

    gridState[target] = columns;
    applyCollectionToolbarState();
  });

  document.addEventListener('product-grid:updated', applyCollectionToolbarState);
  window.addEventListener('resize', scheduleCollectionToolbarUpdate, { passive: true });
  document.addEventListener('DOMContentLoaded', applyCollectionToolbarState);
  applyCollectionToolbarState();
})();
